// extracted by mini-css-extract-plugin
export default {"container":"sliders_container__H0WQA","imagen-sliders":"sliders_imagen-sliders__fMcgP"};